"use client";

import type { HTMLAttributes } from "react";

import { polymorphicForwardRef } from "../../props";

export type PolyMorphicElementProps = HTMLAttributes<HTMLDivElement>;

/**
 * PolyMorphicElement component is a component that can be used to render any element.
 * It is a wrapper around the native HTML element.
 * It is useful when you want to render a component that can be used as any HTML element.
 */
export const PolyMorphicElement = polymorphicForwardRef<
  "div",
  PolyMorphicElementProps
>(({ as: Element = "div", ...props }, ref) => <Element ref={ref} {...props} />);

PolyMorphicElement.displayName = "PolyMorphicElement";
